module.exports = __webpack_public_path__ + "img/Group-544.97fbfb94.svg";